import { useState } from "react";
import { useFetch, timeAgo } from "@/lib/shieldx";
import { PageHeader, Loader } from "@/components/shieldx/Primitives";
import { StatusBadge, RiskBadge, DemoTag } from "@/components/shieldx/Badges";
import { Table } from "@/components/shieldx/Table";
import { ShieldAlert } from "lucide-react";

const LEVELS = ["ALL", "LOW", "MEDIUM", "HIGH", "CRITICAL"];

export default function Threats() {
  const { data, loading } = useFetch("/threats");
  const [filter, setFilter] = useState("ALL");
  if (loading || !data) return <Loader label="Loading threat feed" />;

  const rows = filter === "ALL" ? data : data.filter((t) => t.risk_level === filter);
  const sorted = [...rows].sort((a, b) => (b.detected_at || "").localeCompare(a.detected_at || ""));

  const columns = [
    { key: "threat_id", label: "ID", render: (r) => <span className="font-mono text-xs text-slate-400">{r.threat_id}</span> },
    { key: "category", label: "Category", render: (r) => <span className="font-medium text-slate-100">{r.category}</span> },
    { key: "target_asset", label: "Target Asset", render: (r) => <span className="font-mono text-[11px] text-slate-400">{r.target_asset}</span> },
    { key: "source_ip", label: "Source", render: (r) => (
      <div><p className="font-mono text-xs text-slate-300">{r.source_ip}</p><p className="font-mono text-[10px] text-slate-600">{r.vpn_proxy_tor}</p></div>
    ) },
    { key: "risk_score", label: "Score", render: (r) => <span className="font-mono tabular-nums text-slate-200">{r.risk_score}</span> },
    { key: "risk_level", label: "Risk", render: (r) => <RiskBadge value={r.risk_level} /> },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "detected_at", label: "Detected", render: (r) => <span className="text-xs text-slate-500">{timeAgo(r.detected_at)}</span> },
  ];

  return (
    <div>
      <PageHeader icon={ShieldAlert} title="Threat Detection"
        subtitle="Real-time detection across authentication, API, automation and AI-agent activity. All events are DEMO / SIMULATED." actions={<DemoTag />} />
      <div className="mb-4 flex flex-wrap gap-2">
        {LEVELS.map((l) => (
          <button key={l} onClick={() => setFilter(l)} data-testid={`threat-filter-${l.toLowerCase()}`}
            className={`rounded-lg border px-3 py-1.5 text-xs font-medium ${filter === l ? "border-blue-500/50 bg-blue-600/15 text-blue-300" : "border-slate-800 bg-slate-900/50 text-slate-400 hover:text-slate-200"}`}>
            {l} {l !== "ALL" && <span className="ml-1 font-mono text-[10px] text-slate-500">{data.filter((t) => t.risk_level === l).length}</span>}
          </button>
        ))}
      </div>
      <Table columns={columns} rows={sorted} testid="threats-table" empty="No threats at this level" />
    </div>
  );
}
